import {
  ErrorHandler,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { UrlInterceptor } from './app/services/url.interceptor';
import { AuthInterceptService } from './app/services/auth-services/auth-intercept.service';
import { LoadingInterceptor } from './app/services/loading/loading.interceptor';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { provideMarkdown } from 'ngx-markdown';
import { bootstrapApplication } from '@angular/platform-browser';
import { NgxEchartsModule } from 'ngx-echarts';
import { AppComponent } from './app/app.component';
import {
  provideRouter,
  RouteReuseStrategy,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';
import { routes } from './app/app.routes';
import { GlobalErrorHandler } from './app/services/error-handler';
import { ParamAwareRouteReuseStrategy } from './app/param-aware-route-reuse.strategy';

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      NgxEchartsModule.forRoot({
        echarts: () => import('echarts/core'),
      })
    ),
    { provide: HTTP_INTERCEPTORS, useClass: UrlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    provideHttpClient(withInterceptorsFromDi()),
    provideMarkdown(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      })
    ),
    provideBrowserGlobalErrorListeners(),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: RouteReuseStrategy, useClass: ParamAwareRouteReuseStrategy },
  ],
}).catch(err => console.error(err));
